import React from 'react'
import { INPUT_BASE } from './constants'

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> { containerStyle?: React.CSSProperties }

export const SearchInput: React.FC<SearchInputProps> = ({ containerStyle, style, ...rest }) => (
  <div style={{ position: 'relative', ...containerStyle }}>
    <span style={{ position: 'absolute', left: '0.65rem', top: '50%', transform: 'translateY(-50%)', fontSize: '0.8rem', color: 'var(--text-muted)', pointerEvents: 'none' }}>🔍</span>
    <input style={{ ...INPUT_BASE, paddingLeft: '2rem', ...style }} {...rest} />
  </div>
)
